import { Injectable, Injector } from '@angular/core'
import { Response, URLSearchParams } from '@angular/http'
import { Observable } from 'rxjs/Observable'

import { KeyTransformer } from 'util/key-transformer'
import { BaseModelService } from './base-model.service'

@Injectable()
export class AvailableLocalesService extends BaseModelService<Object> {
  constructor() {
    super()

    this.configure({
      basePath:  'available_locales',
      key:       'available_locale',
      pluralKey: 'available_locales',
      serializer: null
    })
  }

  index(includeDefault:boolean=false): Observable<Object> {
    let params = {
      include_default: includeDefault ? "1" : "0"
    }
    let searchParams = this.buildUrlSearchParams(params)
    let url = this.buildUrl()
    return this.appHttp.get(url, { search: searchParams }).map((response) => this.processResponse(response))
  }

  protected processResponse(response: Response): Object {
    if(!response.text()) { return null }
    return KeyTransformer.camelize(response.json())
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/available-locales.service.ts